/* ── CAPDAC STUDIO UX & INTERACTIVE JAVASCRIPT SYSTEM ─────────────────── */

// 1. AJAX CART DRAWER
function toggleCartDrawer() {
  var drawer = document.getElementById('cartDrawerBackdrop');
  if (drawer) {
    drawer.classList.toggle('open');
  }
}
window.toggleCartDrawer = toggleCartDrawer;

function closeCartDrawerOnBackdrop(e) {
  if (e.target.id === 'cartDrawerBackdrop') {
    toggleCartDrawer();
  }
}
window.closeCartDrawerOnBackdrop = closeCartDrawerOnBackdrop;

function ajaxAddToCart(variantId, qty) {
  qty = qty || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: qty })
  })
  .then(function() {
    return fetch('/cart.js').then(function(res) { return res.json(); });
  })
  .then(function(cart) {
    renderDrawerCart(cart);
    var drawer = document.getElementById('cartDrawerBackdrop');
    if (drawer && !drawer.classList.contains('open')) {
      drawer.classList.add('open');
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    window.location.href = '/cart';
  });
}
window.ajaxAddToCart = ajaxAddToCart;

function updateDrawerQty(key, newQty) {
  var targetQty = Math.max(0, newQty);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(key), quantity: targetQty })
  })
  .then(function() {
    return fetch('/cart.js').then(function(res) { return res.json(); });
  })
  .then(function(cart) {
    renderDrawerCart(cart);
  })
  .catch(function(err) {
    console.error('Update drawer error:', err);
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) { renderDrawerCart(cart); });
  });
}
window.updateDrawerQty = updateDrawerQty;

function refreshCartDrawer(openAfter) {
  fetch('/cart.js')
  .then(function(response) { return response.json(); })
  .then(function(cart) {
    renderDrawerCart(cart);
    if (openAfter) {
      var drawer = document.getElementById('cartDrawerBackdrop');
      if (drawer && !drawer.classList.contains('open')) {
        drawer.classList.add('open');
      }
    }
  })
  .catch(function(err) {
    console.error('Refresh cart error:', err);
  });
}
window.refreshCartDrawer = refreshCartDrawer;

function formatMoney(cents) {
  return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '₺';
}

function renderDrawerCart(cart) {
  if (!cart) return;

  var countEl = document.getElementById('drawerCartCount');
  var headerCountEl = document.getElementById('headerCartBtn');
  var itemsEl = document.getElementById('drawerCartItems');
  var footerEl = document.getElementById('drawerCartFooter');
  var subtotalEl = document.getElementById('drawerSubtotal');
  var freeTextEl = document.getElementById('freeShippingText');
  var fillEl = document.querySelector('.free-shipping-progress .progress-fill');

  var itemCount = cart.item_count || 0;
  if (countEl) countEl.textContent = itemCount;
  var menuCartCount = document.getElementById('drawerMenuCartCount');
  if (menuCartCount) menuCartCount.textContent = itemCount;
  var stickyBadge = document.getElementById('mobileStickyCartBadge');
  if (stickyBadge) {
    stickyBadge.textContent = itemCount;
    stickyBadge.style.display = (itemCount > 0 ? 'flex' : 'none');
  }
  var headerBadge = document.getElementById('headerCartBadge');
  if (headerBadge) {
    headerBadge.textContent = itemCount;
    headerBadge.style.display = (itemCount > 0 ? 'flex' : 'none');
  }

  // Also update all .cart-btn on page
  document.querySelectorAll('.cart-btn').forEach(function(btn) {
    btn.textContent = 'SEPET (' + itemCount + ')';
  });

  // 100% Free Shipping everywhere
  if (freeTextEl && fillEl) {
    freeTextEl.innerHTML = 'Tüm Siparişlerde <strong>Ücretsiz Kargo</strong>';
    fillEl.style.width = '100%';
  }

  var totalPrice = cart.total_price || 0;
  if (subtotalEl) subtotalEl.textContent = formatMoney(totalPrice);

  // Sync quick-add buttons on the collection page with exact quantities
  var cartMap = {};
  if (cart.items && cart.items.length > 0) {
    cart.items.forEach(function(item) {
      cartMap[String(item.variant_id)] = item.quantity;
      if (item.id) cartMap[String(item.id)] = item.quantity;
    });
  }

  var containers = document.querySelectorAll('.quick-add-container');
  containers.forEach(function(container) {
    var addBtn = container.querySelector('.btn-quick-add');
    var qtyBox = container.querySelector('.quick-qty-box');
    if (!addBtn || !qtyBox) return;

    var variantId = addBtn.getAttribute('data-variant-id');
    var qtyInCart = cartMap[String(variantId)] || 0;

    if (qtyInCart > 0) {
      addBtn.style.display = 'none';
      qtyBox.style.display = 'flex';
      qtyBox.setAttribute('data-qty', String(qtyInCart));
      var qtyDisplay = qtyBox.querySelector('.qty-display');
      if (qtyDisplay) qtyDisplay.innerText = String(qtyInCart);
    } else {
      addBtn.style.display = 'flex';
      qtyBox.style.display = 'none';
      qtyBox.setAttribute('data-qty', '0');
    }
  });

  if (itemCount === 0) {
    if (footerEl) footerEl.style.display = 'none';
    if (itemsEl) {
      itemsEl.innerHTML = '<div class="drawer-empty-cart"><p>Sepetinizde henüz ürün bulunmuyor.</p><a href="/collections/all" class="btn-outline-minimal" onclick="toggleCartDrawer()">KOLEKSİYONU KEŞFET &rarr;</a></div>';
    }
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  if (itemsEl) {
    var html = '';
    cart.items.forEach(function(item) {
      html += '<div class="drawer-item" data-line-item-key="' + item.key + '">';
      html += '  <div class="drawer-item-img"><img src="' + item.image + '" alt="' + item.title + '"></div>';
      html += '  <div class="drawer-item-info">';
      html += '    <h4 class="drawer-item-title"><a href="' + item.url + '">' + item.product_title + '</a></h4>';
      if (item.variant_title) {
        html += '    <span class="drawer-item-variant">' + item.variant_title + '</span>';
      }
      html += '    <div class="drawer-item-price">' + formatMoney(item.final_line_price) + '</div>';
      html += '    <div class="drawer-qty-wrap">';
      html += '      <button type="button" class="qty-btn" onclick="updateDrawerQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">-</button>';
      html += '      <span class="qty-val">' + item.quantity + '</span>';
      html += '      <button type="button" class="qty-btn" onclick="updateDrawerQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
      html += '      <button type="button" class="remove-btn" onclick="updateDrawerQty(\'' + item.key + '\', 0)">Kaldır</button>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';
    });
    itemsEl.innerHTML = html;
  }
}
window.renderDrawerCart = renderDrawerCart;

// 2. VISUAL SCALE MODAL
function toggleScaleModal() {
  var m = document.getElementById('visualScaleModal');
  if (m) m.classList.toggle('open');
}
window.toggleScaleModal = toggleScaleModal;

function closeScaleModalOnBackdrop(e) {
  if (e.target.id === 'visualScaleModal') toggleScaleModal();
}
window.closeScaleModalOnBackdrop = closeScaleModalOnBackdrop;

// 3. PROJECT ESTIMATOR MODAL
window.estimatorData = { mekan: '', hizmet: '' };

function toggleEstimatorModal() {
  var m = document.getElementById('projectEstimatorModal');
  if (m) {
    m.classList.toggle('open');
    if (m.classList.contains('open')) {
      goToEstimatorStep(1);
    }
  }
}
window.toggleEstimatorModal = toggleEstimatorModal;

function closeEstimatorModalOnBackdrop(e) {
  if (e.target.id === 'projectEstimatorModal') toggleEstimatorModal();
}
window.closeEstimatorModalOnBackdrop = closeEstimatorModalOnBackdrop;

function selectEstimatorOption(key, val, nextStep) {
  window.estimatorData[key] = val;
  var hm = document.getElementById('hiddenMekan');
  var hh = document.getElementById('hiddenHizmet');
  if (hm && key === 'mekan') hm.value = val;
  if (hh && key === 'hizmet') hh.value = val;
  goToEstimatorStep(nextStep);
}
window.selectEstimatorOption = selectEstimatorOption;

function goToEstimatorStep(step) {
  var s1 = document.getElementById('estimatorStep1');
  var s2 = document.getElementById('estimatorStep2');
  var s3 = document.getElementById('estimatorStep3');
  var s4 = document.getElementById('estimatorSuccessStep');

  if (s1) s1.style.display = (step === 1 ? 'block' : 'none');
  if (s2) s2.style.display = (step === 2 ? 'block' : 'none');
  if (s3) s3.style.display = (step === 3 ? 'block' : 'none');
  if (s4) s4.style.display = (step === 4 ? 'block' : 'none');

  if (step === 3) {
    var summary = document.getElementById('estimatorSummaryText');
    if (summary) {
      summary.innerHTML = 'Seçilen: <strong>' + (window.estimatorData.mekan || 'Özel Mekan') + '</strong> &bull; <strong>' + (window.estimatorData.hizmet || 'Mimari Tasarım') + '</strong>';
    }
  }
}
window.goToEstimatorStep = goToEstimatorStep;

function handleEstimatorSubmit(e, form) {
  e.preventDefault();
  var btn = document.getElementById('estimatorSubmitBtn');
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'GÖNDERİLİYOR...';
  }

  var noteField = document.getElementById('estNote');
  var existingNote = noteField ? noteField.value : '';
  if (noteField) {
    noteField.value = 'Mekan Türü: ' + (window.estimatorData.mekan || '-') + ' | ' +
                      'Hizmet Türü: ' + (window.estimatorData.hizmet || '-') + ' | ' +
                      'Müşteri Notu: ' + existingNote;
  }

  var formData = new FormData(form);

  fetch('/contact', {
    method: 'POST',
    body: formData
  })
  .then(function() {
    goToEstimatorStep(4);
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'KEŞİF & TEKLİF TALEBİNİ İLET →';
    }
  })
  .catch(function(err) {
    console.error('Estimator submit error:', err);
    goToEstimatorStep(4);
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'KEŞİF & TEKLİF TALEBİNİ İLET →';
    }
  });
}
window.handleEstimatorSubmit = handleEstimatorSubmit;

// 4. CANLI KAMERA (AR CAMERA SIMULATION)
var currentScale = 1.0;
var arStream = null;

function startArCamera() {
  var modal = document.getElementById('arCameraModal');
  if (modal) modal.classList.add('open');

  var video = document.getElementById('arVideoFeed');
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
    .then(function(stream) {
      arStream = stream;
      video.srcObject = stream;
    })
    .catch(function(err) {
      console.warn('Camera access error or desktop fallback:', err);
    });
  }
  setupArDrag();
}
window.startArCamera = startArCamera;

function stopArCamera() {
  var modal = document.getElementById('arCameraModal');
  if (modal) modal.classList.remove('open');

  if (arStream) {
    arStream.getTracks().forEach(function(track) { track.stop(); });
    arStream = null;
  }
}
window.stopArCamera = stopArCamera;

function closeArModalOnBackdrop(e) {
  if (e.target.id === 'arCameraModal') stopArCamera();
}
window.closeArModalOnBackdrop = closeArModalOnBackdrop;

function adjustArLampScale(delta) {
  currentScale = Math.max(0.4, Math.min(2.5, currentScale + delta));
  var lamp = document.getElementById('arLampOverlay');
  if (lamp) {
    lamp.style.transform = 'translate(-50%, -50%) scale(' + currentScale + ')';
  }
}
window.adjustArLampScale = adjustArLampScale;

function setupArDrag() {
  var lamp = document.getElementById('arLampOverlay');
  var container = document.getElementById('arCameraContainer');
  if (!lamp || !container) return;

  var isDragging = false;

  function move(e) {
    if (!isDragging) return;
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    var rect = container.getBoundingClientRect();
    var x = clientX - rect.left;
    var y = clientY - rect.top;
    lamp.style.left = x + 'px';
    lamp.style.top = y + 'px';
  }

  lamp.addEventListener('mousedown', function() { isDragging = true; });
  lamp.addEventListener('touchstart', function() { isDragging = true; }, { passive: true });
  window.addEventListener('mouseup', function() { isDragging = false; });
  window.addEventListener('touchend', function() { isDragging = false; });
  container.addEventListener('mousemove', move);
  container.addEventListener('touchmove', move, { passive: true });
}

// 5. 3D AR MODAL
function toggleCapdacArModal() {
  var m = document.getElementById('capdacArModal');
  if (m) m.classList.toggle('open');
}
window.toggleCapdacArModal = toggleCapdacArModal;

function closeCapdacArOnBackdrop(e) {
  if (e.target.id === 'capdacArModal') toggleCapdacArModal();
}
window.closeCapdacArOnBackdrop = closeCapdacArOnBackdrop;

// 6. STICKY ADD TO CART OBSERVER
document.addEventListener('DOMContentLoaded', function() {
  var mainAddToCartBtn = document.querySelector('.product-form form button[type="submit"], .btn-hero-primary');
  var stickyBar = document.getElementById('stickyAddToCartBar');

  if (mainAddToCartBtn && stickyBar) {
    window.addEventListener('scroll', function() {
      var rect = mainAddToCartBtn.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
  }
});

// 7. RECENTLY VIEWED PRODUCTS
function saveCurrentProduct(handle, title, price, imgUrl, url) {
  if (!handle) return;
  var recent = JSON.parse(localStorage.getItem('capdac_recent_v2') || '[]');
  recent = recent.filter(function(p) { return p.handle !== handle; });
  recent.unshift({ handle: handle, title: title, price: price, imgUrl: imgUrl, url: url });
  if (recent.length > 4) recent = recent.slice(0, 4);
  localStorage.setItem('capdac_recent_v2', JSON.stringify(recent));
}
window.saveCurrentProduct = saveCurrentProduct;

function renderRecentlyViewed() {
  var grid = document.getElementById('recentlyViewedGrid');
  var section = document.getElementById('recentlyViewedSection');
  if (!grid || !section) return;

  var currentHandle = window.location.pathname.split('/').pop();
  var recent = JSON.parse(localStorage.getItem('capdac_recent_v2') || '[]');
  var otherRecent = recent.filter(function(p) { return p.handle !== currentHandle; });
  
  if (otherRecent.length === 0) {
    section.style.display = 'none';
    return;
  }

  var html = '';
  otherRecent.slice(0, 4).forEach(function(p) {
    html += '<div class="recent-compact-card">';
    html += '  <a href="' + p.url + '" class="recent-thumb-wrap"><img src="' + p.imgUrl + '" alt="' + p.title + '"></a>';
    html += '  <div class="recent-compact-info">';
    html += '    <h4 class="recent-compact-title"><a href="' + p.url + '">' + p.title + '</a></h4>';
    html += '    <span class="recent-compact-price">' + p.price + '</span>';
    html += '    <a href="' + p.url + '" class="btn-recent-view">İNCELE &rarr;</a>';
    html += '  </div>';
    html += '</div>';
  });

  grid.innerHTML = html;
  section.style.display = 'block';
}

document.addEventListener('DOMContentLoaded', renderRecentlyViewed);

// 8. MOBILE CAROUSEL DOTS & SCROLL TRACKER
function initMobileCarouselDots() {
  if (window.innerWidth > 768) return;

  var carouselSelectors = [
    '.lighting-products-grid',
    '.arch-services-grid',
    '.process-steps-grid',
    '.journal-articles-grid',
    '.team-preview-grid',
    '.mimarlik-detail-grid',
    '.arch-steps-container',
    '.aydinlatma-cats-grid',
    '.magazine-secondary-grid',
    '#recentlyViewedGrid',
    '.about-features-grid',
    '.social-proof-grid'
  ];

  carouselSelectors.forEach(function(selector) {
    var container = document.querySelector(selector);
    if (!container) return;

    var children = Array.from(container.children).filter(function(el) {
      return !el.classList.contains('carousel-dots-wrap');
    });
    if (children.length <= 1) return;

    var existingDots = container.parentElement.querySelector('.carousel-dots-wrap');
    if (existingDots) existingDots.remove();

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'carousel-dots-wrap';

    children.forEach(function(child, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel-dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Slayt ' + (index + 1));
      dot.addEventListener('click', function() {
        var cardWidth = children[0].offsetWidth + 16;
        container.scrollTo({ left: index * cardWidth, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    container.parentElement.appendChild(dotsWrap);

    container.addEventListener('scroll', function() {
      var cardWidth = children[0].offsetWidth + 16;
      var activeIndex = Math.round(container.scrollLeft / cardWidth);
      var dots = dotsWrap.querySelectorAll('.carousel-dot');
      dots.forEach(function(d, i) {
        if (i === activeIndex) {
          d.classList.add('active');
        } else {
          d.classList.remove('active');
        }
      });
    }, { passive: true });
  });
}

document.addEventListener('DOMContentLoaded', initMobileCarouselDots);
window.addEventListener('resize', initMobileCarouselDots);

// Back to top button
window.addEventListener('scroll', function() {
  var btn = document.getElementById('btnBackToTop');
  if (btn) {
    if (window.scrollY > 400) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  }
}, { passive: true });

// Scroll reveal observer
(function() {
  if (!('IntersectionObserver' in window)) return;
  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-card, .section-title, .section-subtitle, .lighting-product-card, .arch-service-card, .process-step, .journal-article, .team-member, .about-feature, .social-proof-item').forEach(function(el) {
      el.classList.add('scroll-reveal');
      revealObserver.observe(el);
    });
  });
})();

// Page ready fade-in
document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('page-ready');
  refreshCartDrawer(false);
});

// ── Mandatory Legal Terms Checkbox Handler ─────────────────────────────────
function toggleDrawerCheckoutBtn() {
  var cb = document.getElementById('drawerTermsCheckbox');
  var btn = document.getElementById('drawerCheckoutBtn');
  if (cb && btn) {
    if (cb.checked) {
      btn.disabled = false;
      btn.classList.remove('disabled');
    } else {
      btn.disabled = true;
      btn.classList.add('disabled');
    }
  }
}
window.toggleDrawerCheckoutBtn = toggleDrawerCheckoutBtn;

function handleDrawerCheckout(e) {
  var cb = document.getElementById('drawerTermsCheckbox');
  if (!cb || !cb.checked) {
    if (e) e.preventDefault();
    alert("Lütfen devam etmek için Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmesi'ni onaylayınız.");
    return false;
  }
  window.location.href = '/checkout';
}
window.handleDrawerCheckout = handleDrawerCheckout;

function toggleNewsletterBtn(cb) {
  var btn = document.getElementById('footerNewsletterSubmit');
  if (btn) {
    btn.disabled = !cb.checked;
  }
}
window.toggleNewsletterBtn = toggleNewsletterBtn;
